import { useAuth } from 'hooks/useAuth';
import { CustomGrid, Spinner } from 'ui';
import { LoginStyleContainer } from './LoginStyleContainer';
import { useIntl } from 'react-intl';
import useQueryApiClient from '../../../utils/useQueryApiClient';
import { fetchCsrfCookie } from '../../../utils/csrfCookie';
import { RolesContainer, RoleWrapper } from './style';
import { FallbackImage } from '../../../ui/UploadImage/fallBack/FallBackImage';
import React from 'react';
import { adminPath } from 'enums/adminRoutes';

export const Roles = () => {
  const { farms, isFetchingUser } = useAuth();
  const intl = useIntl();

  const { appendData } = useQueryApiClient({
    request: {
      url: `/api/v2/user/farm-change/:id`,
      method: 'PATCH',
    },
    onSuccess: () => {
      window.location.href = adminPath.base();
    },
  });

  const confirm = async (farmId: number | undefined) => {
    await fetchCsrfCookie();

    if (farmId) {
      appendData([], { id: farmId });
    }
  };

  return (
    <Spinner spinning={isFetchingUser} dontRender>
      <LoginStyleContainer>
        <RolesContainer>
          <div className="role-title">
            {intl.formatMessage({ id: 'roles.choose_information' })}
          </div>
          <div className="role-title">
            {intl.formatMessage({ id: 'roles.choose_role_main' })}
          </div>
          <CustomGrid gapRow={20} gapCol={20}>
            {farms.map((farm) => (
              <RoleWrapper onClick={() => confirm(farm.id)}>
                <FallbackImage
                  src={farm.logo}
                  type={'FarmCard'}
                  preview={false}
                />
                <div>{farm.brand ?? farm.name}</div>
              </RoleWrapper>
            ))}
          </CustomGrid>
        </RolesContainer>
      </LoginStyleContainer>
    </Spinner>
  );
};
